<div [class.estimatingpanel-active]="appMain.estimatingPanelActive" class="estimatingpanel-wrapper">
    <app-estimating-notes></app-estimating-notes>
</div>
